<template>
  <div class="page-content">
    <page-template
      ref="warehouseTemplate"
      :tableOptions="tableOptions"
      :searchOptions="searchOptions"
      :toolConfig="toolConfig"
      :addColumns="addColumns"
      :editColumns="editColumns"
    ></page-template>
  </div>
</template>
<script>
  import pageTemplate from "@/components/template/pageTemplate";
  import api from "@/config/api";
  import userPower from "@/mixin/userPower";

  export default {
    mixins: [userPower],
    components: {
      pageTemplate,
    },
    data() {
      return {
        dialogVisibility: false,
        // 高级搜索条件
        searchOptions: {
          simple: [
            // {
            //   label: "仓库名称",
            //   prop: "name",
            //   type: "input",
            //   span: 12,
            //   placeholder: "请输入仓库名称",
            //   isFuzzy: true,
            // },
            // {
            //   label: "仓库编码",
            //   prop: "number",
            //   type: "input",
            //   span: 12,
            //   placeholder: "请输入仓库编码",
            //   isFuzzy: true,
            // },
            {
              label: "门店名称",
              type: "select",
              prop: "storeId",
              span: 12,
              isHasAll: true,
              data: [],
              url: api.store.store,
            },
          ],
        },
        // 更多功能
        toolConfig: [
          {
            label: "添加",
            code: "insert",
          },
          {
            label: "同步",
            code: "sync",
            callback: this.sync,
            filter:()=>{
              return false
            }
          },
          {
            label: "删除",
            code: "delete",
            type: this.$utils.buttonType.tableOperate,
            filter:()=>{
              return false
            }
          },
          {
            label: "编辑",
            code: "update",
            type: this.$utils.buttonType.tableOperate,
          },
        ],
        // 表格信息配置
        tableOptions: {
          indexShow: true, //是否显示索引
          showSelect: true,
          param: {type: 30},
          columns: [
            {
              label: "仓库编码",
              prop: "number",
              width: "120",
              align: "center",
            },
            {
              label: "仓库名称",
              prop: "name",
              width: "190",
              align: "center",
            },
            {
              label: '是否默认仓库',
              selfData:true,
              // type: 'switch',
              prop: 'defaultState',
              width: "120",
              align: "center",
              // change: this.updateDefaultWarehouse
            },
            // {
            //   label: '设置默认仓库',
            //   type: 'switch',
            //   prop: 'defaultState',
            //   width: "120",
            //   align: "center",
            //   change: this.updateDefaultWarehouse
            // },

            {
              label: "联系人",
              prop: "personName",
              width: "120",
              align: "center",
            },
            {
              label: "联系方式",
              prop: "personPhone",
              width: "150",
              align: "center",
            },
            {
              label: "面积",
              prop: "measureArea",
              width: "130",
              align: "center",
            },
            {
              label: "地址",
              prop: "address",
              width: "160",
              align: "center",
            },
            {
              label: "创建时间",
              prop: "createDttm",
              width: "150",
              align: "center",
            },
            // {
            //   label: "备注",
            //   prop: "remarks",
            //   width: "90",
            //   align: "center",
            // },
          ],
          url: api.warehouse.warehouse,
        },
        // 添加字段
        addColumns: {
          labelWidth: "120px",
          span: 12,
          columns: [
            {
              label: "门店名称",
              type: "select",
              prop: "storeId",
              span: 12,
              isHasAll: true,
              data: [],
              url: api.store.store,
              rule: [
                {required: true, message: "请选择门店", trigger: "blur"},
              ],
            },
            {
              label: "仓库名称",
              type: "input",
              prop: "name",
              rule: [
                {required: true, message: "请输入仓库名称", trigger: "blur"},
              ],
            },
            {
              label: "仓库面积",
              type: "inputNumber",
              prop: "measureArea",
              min: 0.001,
              rule: [
                {required: false, message: "请输入仓库面积", trigger: "blur"},
              ],
            },
            {
              label: "负责人",
              type: "input",
              prop: "personName",
              rule: [
                {required: false, message: "请输入负责人", trigger: "blur"},
              ],
            },
            {
              label: "手机号",
              type: "input",
              prop: "personPhone",
              rule: [
                {required: false, message: "请输入手机号", trigger: "blur"},
                {pattern: this.$utils.reg.phone, message: "请输入正确的11位手机号码", trigger: 'blur'}
              ],
              maxLength: 11,
            },
            // {
            //   label: '开启默认仓库',
            //   type: 'switch',
            //   prop: 'defaultState',
            //   change: this.getDefaultWarehouse,
            //   defaultValue: false,
            //   isAllline: true
            // },
            {
              label: "地址",
              type: "casaderSelect",
              prop: "province",
              span: 24,
              // specialRule: [{ required: false }],
              casaderOptions: [
                {
                  prop: "province",
                  data: [],
                  childProps: "city",
                  param: {parentId: 0},
                  url: api.getAreaList,
                  rule: [{required: false, message: "请选择省！"}],
                },
                {
                  prop: "city",
                  data: [],
                  childProps: "area",
                  url: api.getAreaList,
                  rule: [{required: false, message: "请选择市！"}],
                },
                {
                  prop: "area",
                  data: [],
                  url: api.getAreaList,
                  rule: [{required: false, message: "请选择区！"}],
                },
              ],
            },
            {
              label: "详细地址",
              type: "textarea",
              prop: "address",
              span: 22,
            },
            // {
            //   label: "",
            //   type: "map",
            //   prop: "map",
            //   span: 24,
            //   lat: "latitude",
            //   lon: "longitude",
            //   labelWidth: 120,
            // },
          ],
          url: api.warehouse.warehouse,
        },
        // 编辑字段
        editColumns: {
          labelWidth: "120px",
          span: 12,
          columns: [
            {
              label: "仓库编码",
              type: "input",
              prop: "number",
              disabled: true,
            },
            // {
            //   label: "门店名称",
            //   type: "select",
            //   prop: "storeId",
            //   span: 12,
            //   disabled: true,
            //   isHasAll: true,
            //   data: [],
            //   url: api.store.store,
            //   rule: [
            //     {required: true, message: "请选择门店", trigger: "blur"},
            //   ],
            // },
            {
              label: "仓库名称",
              type: "input",
              prop: "name",
              rule: [
                {required: true, message: "请输入仓库名称", trigger: "blur"},
              ],
            },
            {
              label: "仓库面积",
              type: "inputNumber",
              prop: "measureArea",
              min: 0.001,
              rule: [
                {required: false, message: "请输入仓库面积", trigger: "blur"},
              ],
            },
            {
              label: "负责人",
              type: "input",
              prop: "personName",
              rule: [
                {required: false, message: "请输入负责人", trigger: "blur"},
              ],
            },
            {
              label: "手机号",
              type: "input",
              prop: "personPhone",
              rule: [
                {required: false, message: "请输入手机号", trigger: "blur"},
                {pattern: this.$utils.reg.phone, message: "请输入正确的11位手机号码", trigger: 'blur'}
              ],
              maxLength: 11,
            },
            // {
            //   label: '开启默认仓库',
            //   type: 'switch',
            //   prop: 'defaultState',
            //   change: this.getDefaultWarehouse,
            //   defaultValue: false,
            //   isAllline: true
            // },
            {
              label: "地址",
              type: "casaderSelect",
              prop: "province",
              span: 24,
              // specialRule: [{ required: false }],
              casaderOptions: [
                {
                  prop: "province",
                  data: [],
                  childProps: "city",
                  param: {parentId: 0},
                  url: api.getAreaList,
                  rule: [{required: false, message: "请选择省！"}],
                },
                {
                  prop: "city",
                  data: [],
                  childProps: "area",
                  url: api.getAreaList,
                  rule: [{required: false, message: "请选择市！"}],
                },
                {
                  prop: "area",
                  data: [],
                  url: api.getAreaList,
                  rule: [{required: false, message: "请选择区！"}],
                },
              ],
            },
            {
              label: "详细地址",
              type: "textarea",
              prop: "address",
              span: 22,
            },
            // {
            //   label: "",
            //   type: "map",
            //   prop: "map",
            //   span: 24,
            //   lat: "latitude",
            //   lon: "longitude",
            //   labelWidth: 120,
            // },
          ],
          url: api.warehouse.warehouse,
        },
      };
    },
    created() {
      this.setStoreIdNull(this.searchOptions.simple);
      this.setStoreIdNull(this.addColumns.columns);
      // this.setStoreIdNull(this.editColumns.columns);
    },
    methods: {
      sync() {
        // 门店集合
        let ids = this.$refs.warehouseTemplate.getSimpleParams();
        if (!ids) {
          this.$message({message: "请选择门店后进行同步", type: "warning"});
          return;
        }
        // 需要同步的数据
        let tableRows = this.$refs.warehouseTemplate.getTableSelectRow();
        if (tableRows.length === 0) {
          this.$message({message: "请勾选一条数据后进行同步", type: "warning"});
          return;
        }
        this.$axios
          .fetchPost(api.warehouse.warehouse + "/sync", {
            warehouseList: tableRows,
            ...ids,
          })
          .then((data) => {
            if (data.code === 200 && data.data) {
              this.$notify({
                type: "success",
                title: '同步操作',
                message: '成功',
                showClose: false,
              });
              // this.$message({message: "同步成功", type: "success"});
            } else {
              this.$message({message: data.msg, type: "error"});
            }
          })
          .catch((err) => {
            this.$notify({
              type: "error",
              title: '同步操作',
              message: '失败',
              showClose: false,
            });
            // this.$message({message: "请求失败！", type: "error"});
          });
      },
      getDefaultWarehouse(form) {
        let user = this.$utils.getSysUser();
        //获取当前用户的默认仓库
        if (form.defaultState) {
          this.$axios.fetchPost(api.warehouse.warehouse + '/list', {
            defaultState: true,
            relateType: user.type
          }).then(data => {
            if (data.code === 200) {
              data.data.map(item => {
                if (data.data.length > 0) {
                  if (form.id === undefined) {
                    this.$message({message: '已存在默认仓库，请不要重复设置', type: "warning"});
                    form.defaultState = false;
                  } else {
                    if (item.id !== form.id) {
                      this.$message({message: '已存在默认仓库，请不要重复设置', type: "warning"});
                      form.defaultState = false;
                    }
                  }
                }
              });
            } else {
              this.$message({message: data.message, type: "error"});
            }
          })
        }
      },
      updateDefaultWarehouse(form) {
        if (form.defaultState) {
          this.$axios.fetchPost(api.warehouse.warehouse + '/setting/default', form).then(data => {
            if (data.code === 200) {
              this.$refs.warehouseTemplate.$refs.tableTemp.getTableData();
              //this.$refs.warehouseTemplate.operationSuccess();
              this.$notify({
                type: "success",
                title: '默认仓库设置操作',
                message: '成功',
                showClose: false,
              });
              // this.$message({message: '默认仓库设置成功！', type: "success"});
            } else {
              this.$message({message: data.message, type: "error"});
            }
          })
        } else {
          //不允许关闭默认仓库
          this.$message({message: '默认仓库不能关闭！', type: "warning"});
          form.defaultState = true;
        }
      }
    },
  };
</script>




// WEBPACK FOOTER //
// src/page/warehouse/Query.vue